module.exports = __webpack_public_path__ + "static/img/news-de.11b5665c.jpg";